
import { IConfigRepository } from "Infrastructure/interfaces/IConfigRepository";
import { AppConfigurationData } from "Infrastructure/models/AppConfigurationData";
import AuthService from "Infrastructure/repositories/auth/AuthService";
import { AcquirerType } from "Infrastructure/repositories/auth/IAuthService";
import { getDeviceInfo } from "modules/reactNativeBridge/ReactNativeBridge";

let cachedConfig: AppConfigurationData | null = null;
let pendingRequest: Promise<AppConfigurationData> | null = null;

export const ReactNativeConfigRepository = (): IConfigRepository => {

  const getConfigAsync = async (): Promise<AppConfigurationData> => {
      if (cachedConfig) {
        return cachedConfig;
      }

      if (pendingRequest) {
        return pendingRequest;
      }

      pendingRequest = (async () => {
        const authService = AuthService();
        const deviceInfo = await getDeviceInfo();
        console.log("deviceInfo: LOGIN ", deviceInfo);
        if(deviceInfo) {
          const authResponse = await authService.authenticate(deviceInfo.serialNumber, deviceInfo.serialNumber, AcquirerType.PAGSEGURO);

          cachedConfig = {
            printType: 0,
            ticketNote: "",
            tickectName: "",
            printQRCodeTicket: false,
            cnpj: "",
            userAgent: "",
            urlApp: "",
            equipamentId: authResponse.id,
            token: authResponse.token,
            macAddress: deviceInfo.serialNumber,
          };
          return cachedConfig;
        } else {
          throw new Error("Device info not found");
        }
      })().finally(() => {
        pendingRequest = null;
      });

      return pendingRequest;
    }
  return { getConfigAsync };
};
